import React, { useEffect } from 'react';
import LoadingIndicator from '../../core/LoadingIndicator/LoadingIndicator';
import { useAuth0 } from '../../../providers/Auth0Provider';
import LocalStorage from '../../../utils/LocalStorageService';

const Logout = ({ history }) => {
  const { isAuthenticated, logout } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      LocalStorage.clearReduxLocalStorage();
      logout({
        returnTo: process.env.REACT_APP_AUTH_CONFIG_LOUGOUT_URL,
      });
    } else {
      history.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingIndicator />;
};

export default Logout;
